module.exports = __webpack_public_path__ + "img/agricole.ad300917.jpg";